// Shopify theme snippet: put the selector in an iframe and add its stations to the real cart.
// Not installed or tested yet. Install steps are in shopify/INSTALL.md.
//
// Page markup:
//   <iframe id="psd-selector" src="https://psd-selector.vercel.app" title="Pump station selector"
//           style="width:100%;border:0;min-height:900px"></iframe>
//
// The app sends { type: 'psd:add-to-cart', items: [{ id, quantity, properties }] } once the customer
// has reviewed their stations. This script adds them with /cart/add.js (which supports line item
// properties) and sends the customer to the cart page, so the cart is reviewed before checkout.
//
// Login gate: the selector hides prices until the customer is logged in. The page template signs a token
// for the logged-in customer (data-token on the iframe, empty when logged out). The app asks for it with
// { type: 'psd:ready' }, and this script replies with { type: 'psd:auth', token } to the app's origin only.
// { type: 'psd:login' } sends the customer to the store login page and back to this page afterwards.
(function () {
  var APP_ORIGIN = 'https://psd-selector.vercel.app'; // must match the deployed app exactly
  window.addEventListener('message', function (event) {
    if (event.origin !== APP_ORIGIN) return;
    var data = event.data;
    if (data && data.type === 'psd:ready') {
      var frame = document.getElementById('psd-selector');
      event.source.postMessage({ type: 'psd:auth', token: (frame && frame.getAttribute('data-token')) || '' }, APP_ORIGIN);
      return;
    }
    if (data && data.type === 'psd:login') {
      window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
      return;
    }
    if (!data || data.type !== 'psd:add-to-cart' || !Array.isArray(data.items)) return;

    var items = data.items
      .filter(function (i) { return Number.isInteger(i.id) && Number.isInteger(i.quantity) && i.quantity > 0; })
      .map(function (i) { return { id: i.id, quantity: i.quantity, properties: i.properties || {} }; });
    if (!items.length) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        window.location.href = '/cart';
      })
      .catch(function () {
        event.source.postMessage({ type: 'psd:add-to-cart-failed' }, event.origin);
      });
  });
})();
